module.exports = "img/playLittle2.1b2911.png";